import type { SignalForm } from "@suse-o11y/signal/form";
import React from "react";

import { FormField, type FormFieldProps } from "~/components/form/field";
import { cx } from "~/tools/class-variance";

// The grid has the second row reserved for error messages
export const SettingsSectionFormField = <TForm extends SignalForm>({ className, ...props }: FormFieldProps<TForm>) => (
	<FormField {...props} className={cx("col-span-full grid grid-cols-subgrid grid-rows-[1fr_auto]", className)} />
);
